/** @format */

import React, { useState } from "react";
import style from "./index.module.scss";
import cn from "classnames";
import EyeIcon from "../../shared/icons/EyeIcon";
import CloseIcon from "../../shared/icons/CloseIcon";
import ClosedEye from "../../shared/icons/ClosedEye";
import InputMask from "react-input-mask";

const CustomInput = ({
  onChangeValue = () => void 0,
  inputType = "text",
  isDisabled = false,
  isBgGray = false,
  isPasswordEye = false,
  isDeleteText = false,
  value = "",
  paddingLeft = "",
  prefixStart = "",
  prefixEnd = "",
  maxLength = "",
  placeholder = "",
  labelText = "",
  errorText = "",
  onKeyPress = () => {},
  isPhone = false,
  isBin = false,
  isPhoneCn = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState([]);
  const [isInputFilled, setIsInputFilled] = useState("");

  const onFocus = () => setIsFocused(true);
  const onBlur = () => setIsFocused(false);

  const getValue = (event) => {
    let newValue = isBin ? event.target.value.replace(/[^0-9]/g, "") : event.target.value;
    
    if (isPhoneCn) {
      newValue = isPhoneCn ? event.target.value.replace(/[^0-9]/g, "") : event.target.value;
    }

    if (inputType === "number") {
      newValue = newValue ? Number(newValue) : "";
    }

    onChangeValue(newValue);
    setIsInputFilled(newValue.toString().trim() !== "");
  };

  const clearInput = () => {
    onChangeValue("");
    setIsInputFilled(false);
  };

  const togglePasswordDisplay = (id) => {
    if (passwordVisible.find((i) => i === id)) {
      setPasswordVisible(passwordVisible.filter((i) => i !== id));
    } else {
      setPasswordVisible([...passwordVisible, id]);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div className={style.wrapper}>
        {prefixStart && <span className={style.prefixStart}>{prefixStart}</span>}
        <label
          className={cn(style.labelInp, {
            [style.focusedLabel]: isFocused,
            [style.labelError]: errorText,
          })}
        >
          {labelText}
        </label>
        {isPhone === true ? (
          <InputMask
            mask="+7 (999) 999-99-99"
            value={value}
            onChange={getValue}
            onFocus={onFocus}
            onBlur={onBlur}
            disabled={isDisabled}
            className={cn(style.input, {
              [style.input_pdLeft40]: prefixStart,
              [style.input_pdRight]: prefixEnd,
              [style.input_disabled]: isDisabled,
              [style.input_bg_wgray]: isBgGray,
              [style.input_errorState]: errorText,
            })}
            placeholder={placeholder}
          >
            {(inputProps) => <input {...inputProps} type="text" />}
          </InputMask>
        ) : (
          <input
            type={!isPasswordEye || passwordVisible.find((i) => i === 1) ? inputType : "password"}
            className={cn(style.input, {
              [style.input_pdLeft30]: prefixStart,
              [style.input_pdRight]: prefixEnd,
              [style.input_disabled]: isDisabled,
              [style.input_bg_wgray]: isBgGray,
              [style.input_errorState]: errorText,
            })}
            readOnly={isDisabled}
            disabled={isDisabled}
            value={value}
            placeholder={placeholder}
            onChange={getValue}
            maxLength={maxLength}
            onWheel={(event) => event.target.blur()}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
          />
        )}
        {prefixEnd && <span className={style.prefixEnd}>{prefixEnd}</span>}
        {isPasswordEye && isInputFilled && (
          <button
            type="button"
            className={style.prefixEnd}
            onClick={() => togglePasswordDisplay(1)}
          >
            {!isPasswordEye || passwordVisible.find((i) => i === 1) ? <ClosedEye /> : <EyeIcon />}
          </button>
        )}
        {isDeleteText && isInputFilled && (
          <button type="button" className={style.prefixEnd} onClick={clearInput}>
            <CloseIcon />
          </button>
        )}
      </div>
      {errorText && <div className={style.errorText}>{errorText}</div>}
    </div>
  );
};

export default CustomInput;
